var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpeed = function SvgSpeed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    x: 3,
    y: 3,
    fill: "#E2FFEA",
    rx: 27
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    x: 3,
    y: 3,
    stroke: "#F4FFF7",
    strokeWidth: 6,
    rx: 27
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#51C394",
    d: "m34.935 25.435-4.17 4.17A3.1 3.1 0 0 0 30 29.5a3 3 0 0 0-3 3q.005.389.105.765l-1.17 1.17a1.5 1.5 0 0 0 0 2.13 1.5 1.5 0 0 0 2.13 0l1.17-1.17q.377.1.765.105a3 3 0 0 0 3-3 3.1 3.1 0 0 0-.105-.765l4.17-4.17a1.506 1.506 0 1 0-2.13-2.13M30 16a15 15 0 0 0-15 15 14.87 14.87 0 0 0 2.535 8.34 1.502 1.502 0 0 0 2.49-1.68 12 12 0 1 1 19.95 0 1.5 1.5 0 1 0 2.49 1.68A14.86 14.86 0 0 0 45 31a15 15 0 0 0-15-15"
  })));
};
export default SvgSpeed;